
import AppEditRow from "@/components/stock/EditRow.vue";
import AppStockEditSizeRows from "@/components/stock/StockEditSizeRows.vue";

import Vue from "vue";
import {Product, StockIn} from "@/models/base";
import {AuthService, BookYearService, ProductService, StockService} from "@/services";
import {MODULE} from "@/config/modules";

export default Vue.extend({
	data(){
		return {
			stock: new StockIn(),
			finished: false,
			sizeStocks: [] as StockIn[]
		};
	},
	props: {
		value: {
			type: Object as () => Product,
			required: true,
		},
	},
	computed: {
		productHasSizes():boolean {
			return AuthService.hasModule(MODULE.MATENTABEL) && !!this.value?.SizeTableID;
		},
		valid():boolean {
			if (this.productHasSizes) return this.sizeStocks.length > 0;
			if (this.value?.SerialNumberRequired && this.stock.TrackingNumber.trim() == "") return false;
			return true;
		}
	},
	methods: {
		cancel() {
			this.$emit("cancel");
		},
		async save() {
			await StockService.saveStock(this.productHasSizes ? this.sizeStocks : [this.stock]);
			this.$emit("save");
		},
		onUpdateStock(stock:StockIn){
			this.stock = new StockIn(stock);
		},
	},
	async created(){
		if(!this.value) return;
		this.stock.ProductID = this.value.ID;
		this.stock.Product = this.value;
		this.stock.BookYear = BookYearService.selectedBookYear;
		if(this.value.Sku){
			this.stock.Sku = this.value.Sku;
		}
		if(this.value.MainSupplier !== null){
			this.stock.Supplier = this.value.MainSupplier.Contact;
			this.stock.SupplierID = this.value.MainSupplierID;
		}else{
			let p =  await ProductService.getProduct(this.value.ID);
			if(p.Suppliers){
				let supplier = p.Suppliers.filter((s) => s.ID == p.MainSupplierID)[0];
				if(supplier?.Contact){
					this.stock.Supplier = supplier.Contact;
				}
				this.stock.SupplierID = this.value.MainSupplierID;
			}
		}
		this.stock.Name = this.value.Name;
		if(this.value.BuyNettoPrice){
			this.stock.UnitBuyPrice = this.value.BuyNettoPrice;
		}
		this.finished = true;
	},
	components: {
		AppEditRow,
		AppStockEditSizeRows,
	},
	i18nEx: {
		componentPrefix: "components.stock"
	}
});
